import { IconProps } from ".";
import Icon from "./assets/noConnection.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon44NoConnection(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
